// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"bcb1e022","841":"b355fd7d"}[chunkId] + ".chunk.css";
};